module.exports = __webpack_public_path__ + "img/golog-minidc.de6cf2b2.png";